import {
  columnsGenerator,
  filterConfig,
} from 'apps/investcore/components/notification-log/config';
import apiCall from 'apps/investcore/notification-logs';
import { DynamicFilterForm } from 'common/dynamic-filter-form';
import { DetailPage, ListPage } from 'common/ui/admin-CRUD/page';
import ItemDetail from './detail';

export { default as InvestmentNotificationSendPage } from './send-page';

export const InvestmentNotificationLogListPage = () => (
  <ListPage
    title="All Notification Logs"
    apiCall={apiCall}
    columnsGenerator={columnsGenerator}
    FilterForm={() => <DynamicFilterForm fields={filterConfig} />}
    createUrl="/admin/notification-logs/send"
  />
);

export const InvestmentNotificationLogDetailPage = () => (
  <DetailPage
    title="Notification Log"
    apiCall={apiCall}
    listUrl={`/admin/notification-logs`}
    ItemDetail={ItemDetail}
  />
);
